var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-badge"},[_c('img',{attrs:{"src":require('../../../static/logo.svg'),"alt":"webphone-logo","width":"24","height":"24"}}),_vm._v(" "),_c('span',{staticClass:"app-badge-text"},[_vm._v("Call parking wallboard")])])}
var staticRenderFns = []

export { render, staticRenderFns }